import { combineReducers } from 'redux';
import list from './list';
import show from './show';

export default combineReducers({ list, show });
